import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/Common/UI/DndOverNodeContent.styled.tsx",
    _templateObject2,
    _templateObject3,
    _templateObject4;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
export var TargetNodeContent = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  :before {\n    content: '';\n    position: absolute;\n    z-index: -1;\n    top: 2px;\n    bottom: 2px;\n    left: 4px;\n    right: 4px;\n    background: ", ";\n    background-image: ", ";\n    border-radius: 6px;\n  }\n"])), function (_ref) {
  var background = _ref.background;
  return background && background;
}, function (_ref2) {
  var backgroundImage = _ref2.backgroundImage;
  return backgroundImage && "url(\"".concat(backgroundImage, "\")");
});
export var OverNodeBorder = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  :before {\n    content: '';\n    position: absolute;\n    top: 2px;\n    bottom: 2px;\n    left: 4px;\n    right: 4px;\n    top: 24px;\n    border-bottom: 2px solid rgba(76, 94, 207, 1);\n    border-left: 2px solid rgba(76, 94, 207, 1);\n    border-right: 2px solid rgba(76, 94, 207, 1);\n    height: 6px;\n    z-index: -1;\n  }\n"])));
export var OverNodeTopBorder = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  :before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: ", "px;\n    height: 2px;\n    width: 100%;\n    z-index: -1;\n    background: ", ";\n  }\n"])), function (props) {
  return props.xDiff;
}, function (props) {
  return props.canDrop ? 'rgba(76, 94, 207, 1)' : '#D9575E';
});
export var OverNodeBottomBorder = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  :before {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: ", "px;\n    height: 2px;\n    width: 100%;\n    z-index: -1;\n    background: ", ";\n  }\n"])), function (props) {
  return props.xDiff;
}, function (props) {
  return props.canDrop ? 'rgba(76, 94, 207, 1)' : '#D9575E';
});